import { createSelector } from 'reselect';
import CarditLinkTraceColumns from '../../containers/CarditLinkTraceColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.CARDIT_LINK_TRACE.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_LINK_TRACE.isLoading;

export const getData =
  ReportDefinitions.CARDIT_LINK_TRACE.getDataFunction();

export const getColumns =
  createSelector(getData, CarditLinkTraceColumns);
